module.exports = "module.exports = __webpack_public_path__ + &quot;media/images/goto-2619df203f0ab24fb1181c1137d876af.svg&quot;;"